import styled from 'styled-components';
import { body2Bold, spacing } from 'ui/theme';
import { Description } from './AuthenticationPolicyPage.styled';

const Field = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: ${spacing.plusHalf} 1fr;
  grid-template-rows: ${spacing.plusHalf} auto;
  grid-template-areas: 'checkbox label' '. content';
  margin-bottom: ${spacing.plusHalf};
`;

const Label = styled.label`
  ${body2Bold}
  cursor: pointer;
`;

const Content = styled.div`
  grid-area: content;
`;

type Props = {
  children: React.ReactNode;
  label: string;
  name: string;
  onClick?: () => void;
  description: string | React.ReactNode;
};

export const CheckboxFormField = ({ label, children, name, onClick, description }: Props) => (
  <Field>
    {children}
    <Label htmlFor={name} onClick={onClick}>
      {label}
    </Label>
    <Content>
      {typeof description === 'string' ? <Description>{description}</Description> : description}
    </Content>
  </Field>
);
